import React from "react";
import "./App.css";
import HomeNavbar from "./assests/components/Navbar";
import Main from "./assests/components/main";
import Services from "./assests/components/Services";
import Contact from "./assests/components/Contact";
import Footer from "./assests/components/Footer";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

function App() {
  return (
    <Router>
      <div className="App">
        <Switch>
          <Route path="/contact">
            <HomeNavbar />
            <Contact />
            <Footer />
          </Route>
          <Route path="/services">
            <HomeNavbar />
            <Services />
            <Footer />
          </Route>
          <Route path="/">
            <HomeNavbar />
            <Main />
            <Footer />
          </Route>
        </Switch>
      </div>
    </Router>
  );
}

export default App;
